import React from "react";
import PropTypes from "prop-types";
import MainButton from "../../../atoms/RoundedButton";

import { Link } from "react-router-dom";

import styles from "./MainApp.organisms.Product.LoadFinished.module.scss";
import i18n from "i18n";

export class LoadFinished extends React.Component {
  render() {
    return (
      <div className={styles["load-finished-container"]}>
        <i className={`${styles["load-finished-icon"]} icon-iconos_succes`}></i>
        <div className={styles["load-finished-title"]}>{i18n.t("loading.finished")}</div>
        <div className={styles["load-finished-subtitle"]}>
          {i18n.t("loading.finished.sub")}
        </div>
        <div className={styles["load-finished-button"]}>
          <Link to="/admin/products/load" data-automation-id="load-more-button">
            <MainButton
              legend={i18n.t("add.more.products")}
              state="enabled"
            ></MainButton>
          </Link>
        </div>
        <div className={styles["load-finished-link"]}>
          <Link to="/admin/products">
            <div className={styles["load-finished-link"]} data-automation-id="go-to-product-list">{i18n.t("see.product.list")}</div>
          </Link>
        </div>
      </div>
    );
  }
}

LoadFinished.propTypes = {
  content: PropTypes.any,
  title: PropTypes.string,
  goBackFunc: PropTypes.func,
};

export default LoadFinished;
